import * as React from 'react'
import './cart-upsell.scss'
import { CollectionView } from '../../collections'
import { IProduct, ProductCard } from '../../product'

interface IProps {
  product?: IProduct
  promotionalText?: string
}

export const CartUpsell = ({ product, promotionalText }: IProps): JSX.Element => {
  return (
    <div className="cart-upsell">
      <div className="cart-upsell__header">
        {promotionalText}
      </div>
      <ProductCard view={CollectionView.LIST} {...product} hideMoreInfo={true} />
    </div>
  )
}
